export enum TipoAcionamentoAerador {
    MOTOR = 'motor',
    RELE = 'rele'
}
